(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-slick-slider"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.custom-slick-slider').slick({
    centerMode: true,
    centerPadding: '0',
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    infinite: true,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-shop"]) return;
  try {
    
  $(function(){
  $('.shop_footer_slide').slick({
    autoplay: true, // 自動でスクロール
    autoplaySpeed: 0, // 自動再生のスライド切り替えまでの時間を設定
    speed: 40000, // スライドが流れる速度を設定
    cssEase: "linear", // スライドの流れ方を等速に設定
    slidesToShow: 1, // 表示するスライドの数
    swipe: false, // 操作による切り替えはさせない
    arrows: false, // 矢印非表示
    pauseOnFocus: false, // スライダーをフォーカスした時にスライドを停止させるか
    pauseOnHover: false, // スライダーにマウスホバーした時にスライドを停止させるか
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1, // 画面幅750px以下でスライド3枚表示
           speed: 40000, // スライドが流れる速度を設定
        }
      }
    ]
  });
});

  $(document).ready(function() {
  var pagetop = $('.pagetop');
    $(window).scroll(function () {
       if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
       } else {
            pagetop.fadeOut();
            }
       });
       pagetop.click(function () {
           $('body, html').animate({ scrollTop: 0 }, 500);
              return false;
   });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".collection-button");
    const contents = document.querySelectorAll(".collection-content");

    buttons.forEach(button => {
      button.addEventListener("click", function () {
        const handle = this.dataset.handle;

        // ボタン状態切り替え
        buttons.forEach(b => b.classList.remove("active"));
        this.classList.add("active");

        // 表示切り替え
        contents.forEach(content => {
          if (content.id === "collection-" + handle) {
            content.style.display = "block";
          } else {
            content.style.display = "none";
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
